import styled, {css} from 'styled-components';

import {colors, breakpoint} from 'theme';

export const FormWrapper = styled.div`
    width: 100%;
    margin-left: 0;
    padding-bottom: 50px;

    @media (min-width: ${breakpoint.tablet}) {
        margin-left: 320px;
        width: 300px;
    }
`;

export const FormField = styled.div`
    margin-bottom: 15px;
`;

export const FormContainer = styled.div`
    padding-bottom: 60px;
    box-sizing: border-box;
    position: relative;
`;

export const NavigationButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    width: 100%;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
`;

export const Column = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 200px;
    margin: 0 5px 5px 5px;
`;

export const Fieldset = styled.fieldset`
    border: none;
    padding: 0;
`;

export const FormPartTitle = styled.div`
    font-weight: 700;
    font-size: 12px;
`;

export const ErrorList = styled.ul`
    margin-left: 0;
    padding-left: 17px;
`;
export const ErrorItem = styled.li`
    color: ${colors.danger};
    font-size: 14px;
    line-height: 20px;
`;

export const PreviewFileNameContainer = styled.div`
    margin-bottom: 20px;
`;

export const CountErrorMessage = styled.span`
    padding: 0 10px;
    font-size: 12px;
    line-height: 40px;
    color: ${colors.textMuted};
`;

export const AvailableCodesContainer = styled.div<{noAvailable?: boolean}>`
    font-size: 14px;
    margin-top: 8px;
    ${(p) =>
        p.noAvailable &&
        css`
            color: ${colors.danger};
        `}
`;

export const ProductGroupIconContainer = styled.div`
    padding-top: 23px;
    position: absolute;
    left: -60px;
`;
